import { render, staticRenderFns } from "./ModalExibirNoticiaOGLOBO.vue?vue&type=template&id=416ac4ee&scoped=true"
import script from "./ModalExibirNoticiaOGLOBO.vue?vue&type=script&lang=js"
export * from "./ModalExibirNoticiaOGLOBO.vue?vue&type=script&lang=js"
import style0 from "./ModalExibirNoticiaOGLOBO.vue?vue&type=style&index=0&id=416ac4ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416ac4ee",
  null
  
)

export default component.exports